import { Injectable } from '@angular/core';
import { State } from '@app/store/reducers';
import { CheckAuthenticationStatus } from '@core/auth2/store/auth2.actions';
import { Auth2States } from '@core/auth2/store/auth2.reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthMonitorService {
  private authState$: Observable<Auth2States>;
  private authState: Auth2States;

  constructor(private store: Store<State>) {
    this.authState$ = this.store.select(state => state.auth2.state);
    this.authState$
      .pipe(
        switchMap((authState) => {
          this.authState = authState;
          // this.checkAuthenticationStatus();

          return authState;
        }),
      )
      .subscribe();
  }

  checkAuthenticationStatus() {
    // Don't recheck authentication status if we are already authenticating
    if (
      (this.authState === Auth2States.AUTHENTICATING &&
        location.pathname === '/app/auth2/authenticate') ||
      (this.authState === Auth2States.LOGGED_OUT && location.pathname === '/app/auth2/logout')
    ) {
      return;
    }

    const redirectPath = location.href.replace(location.origin, '');
    if (redirectPath.startsWith('/app/auth2')) {
      this.store.dispatch(CheckAuthenticationStatus({ redirectUrl: null }));
    } else {
      this.store.dispatch(CheckAuthenticationStatus({ redirectUrl: location.href }));
    }
  }
}
